export default {
    gmapKey: 'AIzaSyBusqveV9GQ6pPpfEb9aWdVN9GlPgeIEJg',
    // gmapKey: 'AIzaSyCPOQy9j0sxxC1cLmc1YXSLLlcBvmZp_ZU',//TEST
    tiposPregunta: {
        texto: {
            label: 'Texto',
            opciones: false,
        },
        fecha: {
            label: 'Fecha',
            opciones: false,
        },
        email: {
            label: 'Email',
            opciones: false,
        },
        celular: {
            label: 'Teléfono celular',
            opciones: false,
        },
        entero: {
            label: 'Número entero',
            opciones: false,
        },
        decimal: {
            label: 'Número decimal',
            opciones: false,
        },
        sino: {
            label: 'SI/NO',
            opciones: false,
        },
        "m-radio": {
            label: 'Selección múltiple, unica respuesta (radio)',
            opciones: true,
        },
        "m-select": {
            label: 'Selección múltiple, unica respuesta (select)',
            opciones: true,
        },
        "m-check": {
            label: 'Selección múltiple, múltiple respuesta (check)',
            opciones: true,
        },
        direccion: {
            label: 'Dirección',
            opciones: false,
        },
        documento: {
            label: 'Documento',
            opciones: false,
        },
        imagen: {
            label: 'Imagen',
            opciones: false,
        },
        parrafo: {
            label: 'Parrafo',
            opciones: false,
        },
        politicas: {
            label: 'Políticas',
            opciones: false,
        }       
    },
    operadores: {
        eq: {
            label: 'Igual',
            eval(a, b) {
                return a === b
            }
        },
        ne: {
            label: 'Diferente',
            eval(a, b) {
                return a != b
            }
        },
        gt: {
            label: 'Mayor que',
            eval(a, b) {
                return Number(a) > Number(b)
            }
        },
        gte: {
            label: 'Mayor o igual que',
            eval(a, b) {
                return Number(a) >= Number(b)
            }
        },
        lt: {
            label: 'Menor que',
            eval(a, b) {
                return Number(a) < Number(b)
            }
        },
        lte: {
            label: 'Menor o igual que',
            eval(a, b) {
                return Number(a) <= Number(b)
            }
        },
        all: {
            label: 'Contiene todos',
            eval(a, b) {
                if(!Array.isArray(a)) {
                    a = [a || 'NULL']
                }
                return b.split(',').map(x => x.trim()).every(x => a.map(i => i.trim()).includes(x))
            }
        },
        any: {
            label: 'Contiene algunos',
            eval(a, b) {
                if(!Array.isArray(a)) {
                    a = [a || 'NULL']
                }
                return b.split(',').map(x => x.trim()).some(x => a.map(i => i.trim()).includes(x))
            }
        },
        none: {
            label: 'No contiene',
            eval(a, b) {
                if(!Array.isArray(a)) {
                    a = [a || 'NULL']
                }
                return !b.split(',').map(x => x.trim()).some(x => a.map(i => i.trim()).includes(x))
            }
        }
    }
}